import { render } from "./SpamNumberListItem.vue?vue&type=template&id=221149b6&ts=true"
import script from "./SpamNumberListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpamNumberListItem.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/spam-number/components/SpamNumberListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "221149b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('221149b6', __exports__)) {
    api.reload('221149b6', __exports__)
  }
  
  module.hot.accept("./SpamNumberListItem.vue?vue&type=template&id=221149b6&ts=true", () => {
    api.rerender('221149b6', render)
  })

}


export default __exports__